(function() {
    // Execute immediately to catch scripts injected by content_for_header
    deferThirdPartyScripts();
    
    function deferThirdPartyScripts() {
        // Liste des domaines tiers à optimiser
        var thirdPartyDomains = [
            'api.intelligems.io',
            'europe-west1-sonorous-dragon-276210.cloudfunctions.net',
            'tk.beau-domaine.com',
            's3.eu-west-1.amazonaws.com',
            'static.rechargecdn.com',
            'fpmsr.beau-domaine.com',
            'www.googletagmanager.com'
        ];
        
        // Patterns pour identifier des scripts spécifiques qui doivent être différés
        var scriptPatterns = [
            /rechargecdn\.com.*widget\.min\.js/i,
            /fpmsr\.beau-domaine\.com/i,
            /gtag\/js/i,
            /googletagmanager\.com\/gtag\/js/i
        ];
        
        // Mappings pour éviter les redirections HTTP (source -> destination finale)
        var redirectMappings = {
            'https://halc.iadvize.com/iadvize.js': 'https://halc.iadvize.com/static/livechat/ecc8f054d376a064689ae8164092c1e13e14d315/live.js'
        };
        
        // Trouver tous les scripts correspondant aux domaines tiers
        var scripts = document.querySelectorAll('script[src]');
        scripts.forEach(function(script) {
            if (script.src) {
                // Vérifier et corriger les redirections HTTP pour iAdvize
                var scriptUrl = script.src.split('?')[0]; // Enlever les query params pour la comparaison
                if (redirectMappings.hasOwnProperty(scriptUrl)) {
                    script.src = redirectMappings[scriptUrl];
                    script.setAttribute('data-redirect-fixed', 'true');
                }
                
                var isThirdParty = thirdPartyDomains.some(function(domain) {
                    return script.src.indexOf(domain) > -1;
                });
                
                // Vérifier aussi les patterns pour Recharge et GTM
                var matchesPattern = scriptPatterns.some(function(pattern) {
                    return pattern.test(script.src);
                });
                
                if (isThirdParty || matchesPattern) {
                    // Si le script n'est pas encore chargé, le rendre asynchrone et le différer
                    if (!script.async && !script.defer && !script.hasAttribute('data-async-processed')) {
                        script.setAttribute('data-async-processed', 'true');
                        // Utiliser defer pour les scripts non-critiques afin qu'ils n'interfèrent pas avec le parsing
                        script.defer = true;
                        script.async = false;
                    }
                }
            }
        });
    }
    
    // Utiliser MutationObserver pour capturer les scripts ajoutés dynamiquement
    if (typeof MutationObserver !== 'undefined') {
        var observer = new MutationObserver(function(mutations) {
            deferThirdPartyScripts();
        });
        
        observer.observe(document.head, {
            childList: true,
            subtree: true
        });
        
        // Observer aussi le body pour les scripts injectés plus tard
        if (document.body) {
            observer.observe(document.body, {
                childList: true,
                subtree: true
            });
        }
        
        // Arrêter l'observation après 8 secondes pour capturer les scripts tardifs
        setTimeout(function() {
            observer.disconnect();
        }, 8000);
    }
})();
